// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Haa-z","narrowOptionButtons":"Iaa-z","noOptions":"Jaa-z"};